<template>
  <div class="news-detail-container">
    <div class="meta">
      <h1 class="title">{{ title }}</h1>
      <div class="info">
        <span>{{ createTime }} </span>
        <span style="margin-left: 10px">{{ author }}</span>
        <span style="margin-left: 10px">
          {{ $t('com.p3') }} {{ readCount }}
        </span>
      </div>
    </div>

    <div class="content wangeditor" v-html="content"></div>
  </div>
</template>

<script>
import { getLang } from '@/locale/utils';

export default {
  data() {
    return {
      title: '',
      createTime: '',
      author: '',
      content: '',
      readCount: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const res = await this.$http.get(
        '/api/news/info',
        { id: this.$route.params.id },
        { headers: { lang: getLang() } }
      );

      if (res.code == 200 && res.data) {
        this.title = res.data.trans.title;
        this.createTime = res.data.create_time;
        this.author = res.data.trans.author;
        this.content = res.data.trans.content;
        this.readCount = res.data.pv;
      }
    },
  },
};
</script>

<style>
.news-detail-container .content img,
video {
  display: inline-block;
  max-width: 100%;
}
</style>

<style lang="less" scoped>
.news-detail-container {
  padding-top: 120px;
  max-width: 80%;
  margin: 0 auto;
}

.meta {
  width: 60%;
  margin: 0 auto;

  .title {
    font-size: 32px;
    text-align: center;
  }

  .info {
    font-size: 20px;
    color: #333;
    text-align: center;
    margin-top: 12px;
  }
}

.content {
  width: 60%;
  margin: 40px auto 0;
}

@media screen and (max-width: 900px) {
  .meta {
    width: 90%;
  }
  .news-detail-container {
    max-width: 100%;
    padding-left: 24px;
    padding-right: 24px;

    .content {
      width: 90%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newsDetail.vue